<div class="access-denied">
  <mat-icon class="material-icons-outlined access-denied__icon">do_disturb_on</mat-icon>
  <div class="access-denied__header">Access Denied</div>
  <div class="access-denied__info">
    You don’t have permission to access this resource. If you believe this is an error, please contact your
    administrator.
  </div>
</div>
